export const formatDaysLeft = (daysLeft: number) =>
  `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}`;
